import React, {Component} from 'react'
import {withTranslation} from "react-i18next";
import styles from './../../../SearchWidget.module.scss';
import OutsideClickWatcher from "../../../../Common/OutsideClickWatcher";
import DatePicker from "../../../../Common/DatePicker/DatePicker";
import VisibilityWrapper from "../../../../Common/VisibilityWrapper";
import responsiveDefinitions from "../../../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";
import WindowEventWatcher from "../../../../Common/WindowEventWatcher";
import {refBlur, refFocus} from "../../../../../tools/tools";
import {updateCourse} from "../../../../../services/flightCourse/actions";
import PropTypes from "prop-types";
import moment from "moment";
import {connect} from "react-redux";
import {DATES_TARGET} from "../../../../../services/flightCourse/errors-controller";
import shiftAware from "../../../../../hoc/ShiftAware/ShiftAware";
import animations from '../../../../../assets/scss/animations/animate.module.scss';
import DoneBtn from "../../../../Common/DoneBtn/DoneBtn";

class DateRangePicker extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pickerOpen: false,
            animationClasses: ''
        };

        this.localContainerRef = React.createRef();
    }

    changeDatesHandler = (dates, e) => {
        const {datesRef, nextRef, updateCourse, course} = this.props;
        this.setState({pickerOpen: false},
            () => {
                updateCourse({...course, dateStart: dates.start, dateEnd: dates.end});
                refBlur(datesRef, this.localContainerRef);
                refFocus(nextRef);
            });
    };

    pickerVisibilityHandler = (variant = null) => {
        if (typeof variant === 'boolean') {
            return this.setState({pickerOpen: variant});
        }

        return this.setState(prevState => ({pickerOpen: !prevState.pickerOpen}));
    };

    keyDownHandler = e => {
        const code = e.code ? e.code : e.key;
        const {prevRef, nextRef} = this.props;

        const {shiftPressed} = this.props;
        if (code === 'Tab' && shiftPressed) {
            this.blurHandler(e);
            refFocus(prevRef);
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        switch (code) {
            case 'Tab':
                this.blurHandler();
                refFocus(nextRef);
                break;
            case 'Escape':
                this.blurHandler();
                break;
            case 'Up':
            case 'ArrowUp':
            case 'Down':
            case 'ArrowDown':
            case 'Right':
            case 'ArrowRight':
            case 'Left':
            case 'ArrowLeft':
                break;
            default:
                return;
        }

        e.stopPropagation();
        e.preventDefault();
    };

    focusHandler = () => {
        const {wasClosedJustNow} = this.state;
        if (wasClosedJustNow) return;
        this.setState({pickerOpen: true, animationClasses: `${animations.animated} ${animations.touchEffect}`});
        setTimeout(() => this.setState({animationClasses: ''}), 500);
    };

    blurHandler = () => {
        const {datesRef} = this.props;
        this.setState({pickerOpen: false, wasClosedJustNow: true}, () => {
            setTimeout(() => this.setState({wasClosedJustNow: false}), 250);
        });
        //this.pickerVisibilityHandler(false);
        refBlur(datesRef, this.localContainerRef);
    };

    strToMomentAndClean = dateStr => {
        if (dateStr instanceof moment && dateStr.isValid()) return dateStr.clone();
        if (!dateStr) return null;

        const date = moment(dateStr);
        if (!date.isValid()) {
            return null;
        }

        return date.clone();
    };

    render() {
        const {pickerOpen, animationClasses} = this.state;
        let {t, datesRef, Styles: responsiveDefinitions, roundTrip, multiCityMode, animated, course} = this.props;
        const {dateStart, dateEnd} = course;
        const contRef = datesRef ? datesRef : this.localContainerRef;
        const isMobile = !responsiveDefinitions.matches(false, false);
        const isRoundTrip = roundTrip === 'RETURN';
        const start = this.strToMomentAndClean(dateStart), end = this.strToMomentAndClean(dateEnd);
        const startLabel = start ? `${start.format('DD')} ${t(start.format('MMMM')).substr(0, 3)}` : '';
        const endLabel = end ? `${end.format('DD')} ${t(end.format('MMMM')).substr(0, 3)}` : '';
        const label = isRoundTrip && start && end
            ? `${startLabel}  -  ${endLabel}`
            : !isRoundTrip && start ? startLabel : '';
        const inputClasses = [styles.input];
        const containerClasses = ['sw-hidden-on-shrink', styles.dateRangePickerContainer];
        if (pickerOpen) containerClasses.push(styles.focused);
        if (animated) containerClasses.push(animationClasses);
        if (multiCityMode && course.errors.some(c => c.target === DATES_TARGET)) {
            containerClasses.push(styles.hasError);
        }

        return (
            <div className={containerClasses.join(' ')}>
                <div className={styles.dates}>
                    <input value={label}
                           title={label}
                           name={'Trip date'}
                           aria-label={'Trip date'}
                           aria-required="true"
                           ref={contRef}
                           tabIndex={0}
                           placeholder={isRoundTrip ? t('Travel dates') : t('Travel date')}
                           className={inputClasses.join(' ')}
                           onClick={this.focusHandler}
                           onFocus={this.focusHandler}
                           readOnly/>
                </div>
                <VisibilityWrapper visible={pickerOpen}>
                    <WindowEventWatcher eventName={'keydown'}
                                        listening={pickerOpen}
                                        handlerFn={this.keyDownHandler}/>
                    <OutsideClickWatcher handleClickOutside={this.blurHandler}>
                        <div className={styles.calendarPickerContainer}>
                            <DatePicker
                                calendars={isMobile ? 1 : 2}
                                isRangePicker={isRoundTrip}
                                abstractToDecades={false}
                                acceptKeyboardControls
                                start={start}
                                end={end}
                                mobile={isMobile}
                                availableRange={{start: moment(), end: moment().add(361, 'day')}}
                                selectedDateHandler={this.changeDatesHandler}
                                selectedRangeHandler={this.changeDatesHandler}
                                t={t}
                            />
                            <DoneBtn clickHandler={this.blurHandler} withIcon/>
                        </div>
                    </OutsideClickWatcher>
                </VisibilityWrapper>
            </div>
        );
    }
}

DateRangePicker.propTypes = {
    course: PropTypes.object,
    updateCourse: PropTypes.func,
    multiCityMode: PropTypes.bool,
    datesRef: PropTypes.any,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    dateEnd: PropTypes.any,
    animated: PropTypes.bool,
};

DateRangePicker.defaultProps = {
    course: null,
    updateCourse: () => null,
    multiCityMode: false,
    datesRef: null,
    prevRef: null,
    nextRef: null,
    dateEnd: null,
    animated: false,
};

const mapStateToProps = state => ({
    roundTrip: state.flightCourse.roundTrip
});

export default withTranslation()(responsiveDefinitions(connect(mapStateToProps, {updateCourse})(shiftAware(DateRangePicker))));
